import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import { Text, Localizer, withText } from 'preact-i18n';
import Markdown from 'preact-markdown';

import localUtil from '../../lib/util';
import fields from '../../lib/fields';

import FormFieldsCompact from '../../components/form/fieldsCompact';
import Input from '../../components/form/input';
import Versions from '../../components/versions';
import TranscribeVideoButton from './transcribe-video-button';

@withText(props => ({
    orderNumber: <Text id='input.orderNumber-help'>orderNumber</Text>,
    name: <Text id='input.name-help'>name</Text>,
    description: <Text id='input.description-help'>description</Text>,
    installation: <Text id='input.installation-help'>installation</Text>,
    url: <Text id='input.url-help'>url</Text>,
}))
@observer
class NewArticle extends Component {
  	constructor(props) {
        super(props);
        this.state = {
            sections: fields.get('article'),
        };
    }

    createArticle = async () => {
        const { callback = () => {} } = this.props;
        const { articleStore } = this.props.stores;
        const { newArticle } = articleStore;
        const response = await articleStore.adminCreate(newArticle);
        if (response.status === 201) {
            callback();
        }
    }

    componentDidMount() {
        const { idx, id, isNew } = this.props;
        const { articleStore } = this.props.stores;
        if (!isNew) {
            // articleStore.adminSetFromIdx(idx);
            articleStore.adminSetFromId(id);
        }
    }

    render() {
        const { week, isNew, drawerLevel } = this.props;
        const { sections } = this.state;
        const { userStore, articleStore } = this.props.stores;
        const { user, isAdmin } = userStore;
        const { newArticle, article } = articleStore;
        const darkmode= util.getNestedValue(user, 'settings.darkmode');

        return (<>
            <div class='w-100 d-flex justify-content-center'>
                <div class='w-100' style='max-width: 960px; padding-top: 20px; padding-bottom: 100px;'>

                    {article && article.id && <Versions stores={this.props.stores} type='article' id={article.id} key={`admin-article-${article.id}`} />}

                    {/* <div class='w-100 d-flex flex-column justify-content-start'>
                        <xmp>{JSON.stringify(user.settings, null, 2)}</xmp>
                    </div> */}
                    {/* <xmp>{JSON.stringify(newCustomer, null, 4)}</xmp> */}
                    <h5 class='ms-3 mb-3'>
                        {isNew ? <Text id='article.new'>New article</Text> : <Text id='article.edit'>Edit article</Text>}
                    </h5>
                    <div class='bg-light d-flex flex-column justify-content-start h-100 pt-3'>
                        <FormFieldsCompact stores={this.props.stores} sections={sections} holdingStore={articleStore} objectName={isNew ? 'newArticle' : 'article'} isNew={isNew} drawerLevel={drawerLevel} isAdmin={true} />
                    </div>

                    {/* Video Transcription Section */}
                    {!isNew && article && article.files && article.files.length > 0 && (
                        <div class='bg-light d-flex flex-column justify-content-start mt-3 p-3'>
                            <h6 class='mb-3'>
                                <i class='fa-solid fa-video me-2' />
                                <Text id='admin.video-transcription'>Video Transcription</Text>
                            </h6>
                            <div class='d-flex flex-column gap-3'>
                                {article.files.map((file, index) => {
                                    // Only show video files
                                    if (!file.mimetype || !file.mimetype.startsWith('video/')) {
                                        return null;
                                    }

                                    return (
                                        <div key={`video-${index}`} class='card'>
                                            <div class='card-body'>
                                                <div class='row'>
                                                    <div class='col-md-6'>
                                                        <h6 class='card-title mb-2'>
                                                            <i class='fa-solid fa-file-video me-2' />
                                                            {file.name || `Video ${index + 1}`}
                                                        </h6>
                                                        {file.s3LinkStreamPreview1 && (
                                                            <img
                                                                src={file.s3LinkStreamPreview1}
                                                                alt={file.name}
                                                                class='img-fluid rounded mb-2'
                                                                style='max-height: 150px; object-fit: cover;'
                                                            />
                                                        )}
                                                        <p class='card-text mb-1'>
                                                            <small class='text-muted'>
                                                                <i class='fa-solid fa-hdd me-1' />
                                                                {(file.bytes / (1024 * 1024)).toFixed(2)} MB
                                                            </small>
                                                        </p>
                                                        {file.s3Link && (
                                                            <a
                                                                href={file.s3Link}
                                                                target='_blank'
                                                                rel='noopener noreferrer'
                                                                class='btn btn-sm btn-outline-secondary rounded-pill mt-2'
                                                            >
                                                                <i class='fa-solid fa-external-link me-1' />
                                                                <Text id='admin.view-video'>View Video</Text>
                                                            </a>
                                                        )}
                                                    </div>
                                                    <div class='col-md-6'>
                                                        <TranscribeVideoButton
                                                            articleId={article.id}
                                                            fileIndex={index}
                                                            file={file}
                                                            language='no'
                                                            onComplete={() => {
                                                                // Reload article to show updated transcript
                                                                articleStore.adminSetFromId(article.id);
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    )}
                    {isNew && <div class='w-100 d-flex flex-column justify-content-start mt-3 px-4 py-3 bg-light fixed-bottom' style={`bottom: 0; left: 0;`}>
                        <button type='button' class='btn btn-primary rounded-pill' onClick={this.createArticle}>
                            {isNew ? <Text id='article.create'>Create article</Text> : <Text id='article.save'>Save article</Text>}
                        </button>
                    </div>}
                </div>
            </div>
        </>);
    }
}

export default NewArticle;
